import { EQueryParameters_2 as ESortBy } from '../../repositories/agent-catalog-search/v2/get-realtors';
import { IApplicationState } from '../../types/redux';
import { ESortFilter } from '../../types/redux/filters';

const mapSortApiToSortFilter = {
  [ESortBy.Age]: ESortFilter.Age,
  [ESortBy.Name]: ESortFilter.Name,
  [ESortBy.OffersCount]: ESortFilter.OffersCount,
};

export function getSort(state: IApplicationState): ESortFilter {
  const { tab } = state;
  const sort = state[tab].filters.sortBy;

  return sort ? mapSortApiToSortFilter[sort] : ESortFilter.Any;
}
